import React from 'react';
import { Section } from '../ui/Section';
import { Gift } from 'lucide-react';
export function Bonuses() {
  const bonuses = [{
    title: 'Plan 7 días',
    desc: 'Tu hoja de ruta exacta'
  }, {
    title: 'Scripts de venta',
    desc: 'Qué decir para cerrar'
  }, {
    title: 'Contenido que vende',
    desc: 'Plantillas listas'
  }, {
    title: 'Checklist iPhone',
    desc: 'Revisión de equipos'
  }, {
    title: 'Ideas digitales',
    desc: 'Productos rentables'
  }, {
    title: 'Sistema diario',
    desc: 'Rutina de éxito'
  }];
  return <Section className="bg-dark-900" data-id="element-18">
      <div className="text-center mb-16" data-id="element-19">
        <h2 className="text-4xl md:text-5xl font-black text-white mb-4 flex items-center justify-center gap-4" data-id="element-20">
          <Gift className="text-gold-500 w-10 h-10" data-id="element-21" />6 BONOS ESTRATÉGICOS
        </h2>
        <p className="text-2xl text-gold-400 font-bold tracking-widest uppercase" data-id="element-22">
          Siempre Incluidos
        </p>
      </div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 mb-16" data-id="element-23">
        {bonuses.map((bonus, idx) => <div key={idx} className="bg-dark-800 border border-dark-700 hover:border-gold-500/50 transition-colors p-6 rounded-2xl relative overflow-hidden group" data-id="element-24">
            <div className="absolute top-0 right-0 w-24 h-24 bg-gold-500/5 rounded-bl-full -mr-4 -mt-4 transition-transform group-hover:scale-110" data-id="element-25" />
            <div className="text-gold-500 mb-4" data-id="element-26">
              <Gift className="w-8 h-8" data-id="element-27" />
            </div>
            <h3 className="text-xl font-bold text-white mb-2" data-id="element-28">
              Bono #{idx + 1}: {bonus.title}
            </h3>
            <p className="text-gray-400" data-id="element-29">{bonus.desc}</p>
          </div>)}
      </div>

      <div className="max-w-2xl mx-auto bg-dark-800 border-2 border-gold-500/30 rounded-2xl p-8 text-center shadow-gold-glow" data-id="element-30">
        <p className="text-xl text-gray-300 mb-2" data-id="element-31">
          Valor total de los bonos:{' '}
          <span className="line-through text-gray-500" data-id="element-32">$53.000</span>
        </p>
        <p className="text-4xl font-black text-transparent bg-clip-text bg-gold-gradient" data-id="element-33">
          👉 HOY GRATIS
        </p>
      </div>
    </Section>;
}